import React from 'react';
import ListHeader from '../ListHeader';
import Guide from './Guide';
import styles from './guides.module.scss';
import projectManagement from './img/project-management@2x.png';
import projectPlanning from './img/project-planning@2x.png';

const Guides = () => (
  <div>
    <ListHeader eyebrow="Guides" text="Go deeper on project management" />
    <div className={styles.Guides}>
      <Guide
        heading="The Guide to Project Management"
        href="https://www.teamgantt.com/guide-to-project-management/"
        imgSrc={projectManagement}
        text="A how-to guide for project managers written by Brett Harned"
      />
      <Guide
        heading="The Guide to Project Planning"
        href="https://www.teamgantt.com/guide-to-project-planning"
        imgSrc={projectPlanning}
        text="A downloadable guide to help you create project plans and keep projects on track"
      />
    </div>
  </div>
);

export default Guides;



// WEBPACK FOOTER //
// ./src/components/guides/index.js